import React from 'react';
import AuditDrawer from '../audit/AuditDrawer';

interface ProjectAuditDrawerProps {
  projectId: string;
  projectName?: string;
  isOpen: boolean;
  onClose: () => void;
}

const ProjectAuditDrawer: React.FC<ProjectAuditDrawerProps> = ({
  projectId,
  projectName,
  isOpen,
  onClose,
}) => {
  return (
    <AuditDrawer
      entityType="PROJECT"
      entityId={projectId}
      entityName={projectName}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default ProjectAuditDrawer;
